<template>
  <div class="server-error text-left">
    <card>
      <div class="mt-4 mb-4">
        <h3 class="mb-4">{{error.title}}</h3>
        <pre class="mt-1 mb-4">{{error.description}}</pre>
      </div>
      <div class="server-error text-center">
        <router-link to="signin" replace>
          <b-button variant="primary" class="mr-3">Sign in</b-button>
        </router-link>
      </div>
    </card>
  </div>
</template>

<script>
import Card from "../ui/Card";

export default {
  name: "Server Error",
  components: {
    Card
  },
  computed: {
    error() {
      if (this.$route.query.code == 10) {
        return {
          title: "Code Expired",
          description:
            "The login code is expired.\nPlease request a new one from the sign in page."
        };
      } else {
        return {
          title: "An error occured.",
          description:
            "We experienced an error processing your request.\nPlease go back to try again."
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h1.display-1 {
  color: #444;
  font-weight: 700 !important;
}
</style>
